import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { JwtPayload } from 'domains/auth/types';
import { HYDRATE } from 'next-redux-wrapper';

import type { HydrateAction } from 'redux-store';

import type { IJwtSliceState } from './types';

const initialState: IJwtSliceState = {
  payload: null,
  token: null,
  error: null,
};

export const JwtSlice = createSlice({
  name: 'jwt',
  initialState,
  reducers: {
    setJwtToken(
      state,
      { payload }: PayloadAction<{ token: string; payload: JwtPayload }>,
    ) {
      state.payload = payload.payload;
      state.token = payload.token;
    },
    setJwtError(
      state,
      { payload }: PayloadAction<{ text: string; code: number }>,
    ) {
      state.error = {
        error_text: payload.text,
        error_code: payload.code,
      };
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: HydrateAction<IJwtSliceState>) => {
      return action.payload.jwt;
    });
  },
});
